module.exports = __webpack_public_path__ + "static/img/tisco.79e3a22b.svg";